import React, { Component } from 'react';
import PropTypes from 'prop-types';

const ga = window.ga;

export default class Link extends Component {
  gaOnClick(e) {
    console.log(this.props.href)
    ga('send', 'event', {
      eventCategory: 'Outbound Link',
      eventAction: 'click',
      eventLabel: this.props.href
    });
  }

  render() {
    return (
      <a
        className={this.props.className}
        onClick={this.gaOnClick.bind(this)}
        href={this.props.href}
        target={this.props.target}
        rel={this.props.rel}
      >
        {this.props.children}
      </a>
    )
  }
}

Link.propTypes = {
  href: PropTypes.string.isRequired,
  className: PropTypes.string,
  target: PropTypes.string,
  rel: PropTypes.string
}



// WEBPACK FOOTER //
// ./src/Components/Link/Link.js